
export default function FormGrid({ children }) {
  return (
      <div className="grid gap-y-4">
        {children}
      </div>
  )
}